import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { PadContainer } from 'smartsuite-ui';

export default function BagSearchResultsSkeleton() {
    return (
        <>
            <Skeleton
                variant="rect"
                animation="wave"
                width="100%"
                height="160px"
            />
            <PadContainer cssClassModifiers={['pad-medium']} />
            <Skeleton
                variant="rect"
                animation="wave"
                width="100%"
                height="160px"
            />
            <PadContainer cssClassModifiers={['pad-medium']} />
            <Skeleton
                variant="rect"
                animation="wave"
                width="100%"
                height="160px"
            />
        </>
    );
}
